module.exports = __webpack_public_path__ + "static/Don-Daniel-3512e0bd7bc4ae2980b2a9402dd3c6b2.png";